// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/BezierSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/BezierSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/BezierSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/BezierSansExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/BezierSansBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../public/fonts/BezierSansRegular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContactUsPage.css */
@font-face {
    font-family: 'Bezier Sans';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
         url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  
    font-family: 'Bezier Sans Extra Bold';
    src: 
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  
    font-family: 'Bezier Sans Bold';
    src: 
         url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  
    font-family: 'Bezier Sans Regular';
    src: 
         url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  body {
    font-family: 'Bezier Sans', sans-serif;
  }
.contact-us-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 150px;
}

.get-in-touch {
    font-family: 'Bezier Sans';
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 20px;
}



@media (max-width: 768px){
    .get-in-touch{
        justify-content: center;
        align-items: center; 
        padding-left: 5%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/contactus/ContactUsPage.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,0BAA0B;IAC1B;;mEAEgE;IAChE,mBAAmB;IACnB,kBAAkB;;IAElB,qCAAqC;IACrC;mEACyE;IACzE,mBAAmB;IACnB,kBAAkB;;IAElB,+BAA+B;IAC/B;mEACoE;IACpE,mBAAmB;IACnB,kBAAkB;;IAElB,kCAAkC;IAClC;mEACuE;IACvE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,sCAAsC;EACxC;AACF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;;;AAIA;IACI;QACI,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;IACpB;AACJ","sourcesContent":["/* ContactUsPage.css */\r\n@font-face {\r\n    font-family: 'Bezier Sans';\r\n    src: url('../../public/fonts/BezierSans.woff2') format('woff2'),\r\n         url('../../public/fonts/BezierSans.woff') format('woff'),\r\n         url('../../public/fonts/BezierSans.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  \r\n    font-family: 'Bezier Sans Extra Bold';\r\n    src: \r\n         url('../../public/fonts/BezierSansExtraBold.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  \r\n    font-family: 'Bezier Sans Bold';\r\n    src: \r\n         url('../../public/fonts/BezierSansBold.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  \r\n    font-family: 'Bezier Sans Regular';\r\n    src: \r\n         url('../../public/fonts/BezierSansRegular.ttf') format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal;\r\n  }\r\n  body {\r\n    font-family: 'Bezier Sans', sans-serif;\r\n  }\r\n.contact-us-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding-top: 150px;\r\n}\r\n\r\n.get-in-touch {\r\n    font-family: 'Bezier Sans';\r\n    font-size: 48px;\r\n    font-weight: bold;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n\r\n\r\n@media (max-width: 768px){\r\n    .get-in-touch{\r\n        justify-content: center;\r\n        align-items: center; \r\n        padding-left: 5%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
